import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getPageTitle } from "../../store/layoutUI";
import Menu from "../../../Components/Navigation/Menu";
import CandidateInfo from "../../components/CandidateInfo";
import PartnerInfo from "../../components/PartnerInfo";
import OnboardingSteps from "../../components/Onboarding/OnboardingSteps";
import EnrollmentSteps from "../../components/Onboarding/EnrollmentSteps";
import TopMenu from "../../components/TopMenu";

const HEADER_HEIGHT = 0;
const SIDE_NAV_WIDTH = 320;
const SIDE_NAV_COLLAPSED_WIDTH = 120;

const LAYOUT_STYLES = {
    page: {
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "linear-gradient(180deg, #f4f7fb 0%, #eef3f8 100%)",
        overflow: "hidden"
    },
    headerWrap: {
        width: "100%",
        flex: "0 0 auto",
        position: "relative",
        zIndex: 30
    },
    bodyWrap: {
        display: "block",
        flex: 1,
        minHeight: 0,
        height: "100%",
        width: "100%",
        boxSizing: "border-box",
        position: "relative",
        overflow: "hidden"
    },
    contentWrap: {
        height: "100%",
        padding: "0px",
        boxSizing: "border-box",
        minWidth: 0,
        maxWidth: "100%",
        overflowX: "hidden",
        width: "100%"
    },
    scrollArea: {
        height: "100%",
        overflowY: "auto",
        overflowX: "hidden",
        width: "100%",
        boxSizing: "border-box",
        minWidth: 0,
        padding: "16px 20px 20px 20px",
        display: "flex",
        flexDirection: "column"
    }
};

const Layout = () => {
    const usrTypeRaw = localStorage.getItem("userType");
    const usrType = (usrTypeRaw?.toLowerCase() === "applicant" || usrTypeRaw?.toLowerCase() === "candidate")
        ? "candidate"
        : (usrTypeRaw?.toLowerCase() || "");
    const pageTitleSelector = useSelector(getPageTitle);
    const [isMenuCollapsed, setIsMenuCollapsed] = useState(true);
    const showCollapsedRail = !isMenuCollapsed;

    useEffect(() => {
        const script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = "/assets/js/argon.js";
        document.body.appendChild(script);
    }, []);

    const location = useLocation();
    const isLandingPage = location.pathname === "/" || location.pathname === "/LandingPage";

    return <div className="main-content" id="panel" style={LAYOUT_STYLES.page}>
        <style>{`
                #sidenav-main {
                    position: absolute !important;
                    top: 0 !important;
                    bottom: 0 !important;
                    left: 0;
                    width: ${showCollapsedRail ? SIDE_NAV_COLLAPSED_WIDTH : SIDE_NAV_WIDTH}px;
                    height: 100% !important;
                    max-height: none !important;
                    z-index: 20;
                    transition: width 0.2s ease;
                    transform: none !important;
                }

                #sidenav-main .sidenav-header {
                    display: flex !important;
                }

                #sidenav-main .navbar-inner {
                    margin-top: 0 !important;
                    padding-bottom: 120px !important;
                }
            `}</style>

        <h1 className="visually-hidden">{pageTitleSelector || "Application"}</h1>

        <div className="w-100 p-0" style={LAYOUT_STYLES.headerWrap}>
            <TopMenu />
        </div>

        <div
            style={{
                ...LAYOUT_STYLES.bodyWrap,
                paddingLeft: `${showCollapsedRail ? SIDE_NAV_COLLAPSED_WIDTH : SIDE_NAV_WIDTH}px`
            }}
        >
            <Menu
                isCollapsed={showCollapsedRail}
                onToggleCollapse={() => setIsMenuCollapsed((prev) => !prev)}
            />

            <div style={LAYOUT_STYLES.contentWrap}>
                <div style={LAYOUT_STYLES.scrollArea}>
                    <div style={{ marginBottom: "16px" }}>
                        {usrType === "candidate" ? <CandidateInfo /> : <PartnerInfo />}
                    </div>
                    {!isLandingPage && (usrType === "candidate" ? <OnboardingSteps /> : <EnrollmentSteps />)}
                    <Outlet />
                </div>
            </div>
        </div>
    </div>
};

export default Layout;
